import { Select as AntSelect, SelectProps } from 'antd'
import styled from 'styled-components'

export const Select = styled(AntSelect)<SelectProps>`
  && {
    &.ant-select-focused.ant-select-outlined:not(.ant-select-disabled)
      .ant-select-selector {
      box-shadow: inset 0 0 0 1px
        ${(props) => props.theme.colors.borderInputFocus};
    }
  }
` as typeof AntSelect
